import React from 'react';

const LoadingOverlay = ({ loading }) => {
  if (!loading) return null;
  return (
    <div className="absolute inset-0 bg-slate-500 bg-opacity-75 flex items-center justify-center z-10 space-x-2">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 m-2"></div>
      <p className="text-gray-300">Loading slide...</p>
    </div>
  );
};
export default LoadingOverlay;
